<template>
  <div class="fox-coins-label-component">
    <div class="foxcoins-add" v-if="showFoxCoinsAdd">
      <span class="foxcoins-pay">&nbsp;+{{ foxCoinsAddCount }}</span>
    </div>
    <div v-if="hasFoxCoinsPay" class="foxcoins-pay">
      {{ foxCoinsCountLabel }}
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import PromoCodeAction from '@/models/enums/PromoCodeAction'
  import BasketStatus from '@/models/enums/BasketStatus'

  export default {
    name: 'FoxCoinLabel',
    computed: {
      ...mapState({
        basket: state => state.baskets.basket,
        order: state => state.orders.currentEditOrder,
      }),
      showFoxCoinsAdd () {
        return this.foxCoinsAddCount > 0 && !this.hasFoxCoinsPay
      },
      isNewOrderCreateInProgress () {
        return this.basket && this.basket.status === BasketStatus.inProcess
      },
      foxCoinsAddCount () {
        return this.basket ? this.basket.foxCoinsAdd : 0
      },
      hasFoxCoinsPay () {
        return this.basket &&
          this.basket.promoCode &&
          this.basket.promoCode.promoCode &&
          this.basket.promoCode.promoCode.action === PromoCodeAction.FoxCoinPay
      },
      foxCoinsCountLabel () {
        return this.foxCoinsCount ? '-' + this.foxCoinsCount : 0
      },
      foxCoinsCount () {
        return this.basket ? this.basket.foxCoinsPayAmount : 0
      },
    },
  }
</script>

<style lang="less" scoped>
.fox-coins-label-component {
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 50px;

  .foxcoins-pay {
    font-size: 16px;
    color: #fe9923;
    display: flex;
    align-items: center;
    line-height: 1.2;
    font-weight: bold;

    &:after {
      display: inline-block;
      height: 20px;
      width: 20px;
      content: '';
      background: url("/img/icons/setcoins-icon.svg") no-repeat center center;
      background-size: contain;
      margin-left: 2px;
      margin-top: -3px;
    }
  }
}

</style>
